































































































import { Component, Vue } from 'vue-property-decorator';
import router from '../router';
import statistics from '@/store/modules/statistics';
import store from '../store/store';
import users from '@/store/modules/users';
import { routerGoto } from '@/store/common';
import managementCompaniesWithReports from '../store/modules/mcsWithReports';

@Component({
  components: {},
  methods: {
    routerGoto,
  },
})
export default class VHome extends Vue {
  private alerts: Array<{type: string, msg: string}> = [];

  get controllerEvents() {
    return statistics.theControllerEvents;
  }

  get loggedIn() {
    return store.getters.loggedIn;
  }

  public beforeMount() {
    // if (!store.state.loggedIn) {
    if (!store.getters.loggedIn) {
      router.replace('/login');
    } else {
      statistics.getControllerEvents({uid: store.getters.user.id, seen: 0})
        .then((events) => {
          // if (addrs && addrs.length != 0) {}
        })
        .catch((error: any) => {
          // console.log(error);
        });

      managementCompaniesWithReports.refreshControllers({uid: store.getters.user.id})
        .then((events) => {
          // if (controllers4mcs.getManagementCompanies)
        })
        .catch((error: any) => {
          // this.alerts.push({type: 'error', msg: 'Не удалось обновить список контроллеров. ' +
          //   'Ошибка на сервере или плохое соединение с интернетом.'});
        });
    }
  }

  // public mounted() {
  //     let url = 'https://raw.githubusercontent.com/FreeCodeCamp/ProjectReferenceData/master/GDP-data.json';
  //     fetch(url)
  //     .then(response => response.json())
  //     .then(json => {
  //         let d3DataX = [];
  //         let d3DataY = [];
  //         let d3Tooltip = [];
  //         json.data.forEach(([date, value]) => {
  //             d3DataX.push(+date.substr(0, 4));
  //             d3DataY.push(value);
  //             d3Tooltip.push(this.formatTooltipData(date, value));
  //         });
  //         this.d3Data = {
  //             x: d3DataX,
  //             y: d3DataY,
  //             tooltip: d3Tooltip
  //         };
  //     })
  //     .catch(error => {
  //         console.error("Error encountered", error);
  //     });
  // }

  // private formatTooltipData (date, value) {
  //   return `
  //     <div>$${value.toLocaleString('en-US')} Billion</div>
  //     <div>${date.substr(0, 4)} - ${(new Date(date)).toLocaleString('en-US', { month: 'long' })}</div>
  //     `;
  // }

  get managementCompanies() {
    return managementCompaniesWithReports.firstMcWithReports;
  }

  // public routerGoto(addr: string) {
  //   router.push(addr);
  // }
}
